import React, { FC, useCallback } from 'react';
import { Text } from '../../..';
import styles from './FolderItem.scss';
import { IOuter } from './FolderItem.types';

export const FolderItem: FC<IOuter> = ({ onClick, item }) => {
  const handleClick = useCallback(() => onClick(item), [onClick, item]);

  return (
    <div className={styles.item} onClick={handleClick}>
      <div className={styles.icon} />
      <Text weight="normal" size="small" tagName="div" ellipsis>
        {item.value.name}
      </Text>
    </div>
  );
};
